import { render, staticRenderFns } from "./marketingLead.vue?vue&type=template&id=63666b24&scoped=true&"
import script from "./marketingLead.vue?vue&type=script&lang=js&"
export * from "./marketingLead.vue?vue&type=script&lang=js&"
import style0 from "./marketingLead.vue?vue&type=style&index=0&id=63666b24&prod&scoped=true&lang=css&"
import style1 from "./marketingLead.vue?vue&type=style&index=1&id=63666b24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63666b24",
  null
  
)

export default component.exports